import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';

import NotFound from 'components/shared/error/not_found';
import useAppContext from 'conf/AppContext';
import Types from 'conf/types';

const propTypes = {
  id: PropTypes.string,
};
/**
 * Redirect Pmid to the related page.
 *
 * @param {object} props - props container
 * @param {string} props.id
 */
export default function RedirectPmid({id}) {
  const appContext = useAppContext();
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      try {
        const rez = await appContext.api.get(`site/pmid/${id}`, {parseJson: true, searchParams: {view: 'min'}});
        if (mounted) {
          if (rez.data.id) {
            appContext.redirect(Types.literature.url(rez.data.id), true);
          } else {
            setError(<NotFound />);
          }
        }
      } catch (err) {
        if (mounted) {
          setError(<NotFound />);
        }
      }
    };
    // noinspection JSIgnoredPromiseFromCall
    loadData();
    return () => {
      mounted = false;
    };
  }, [id]);

  return error;
}
RedirectPmid.propTypes = propTypes;
